import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import API from '../api/api_user'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
const index = r => require.ensure([], () => r(require('@/views/index/index')), 'index');
const min = r => require.ensure([], () => r(require('@/components/min')), 'min');
const login = r => require.ensure([], () => r(require('@/components/login')), 'login');
const not = r => require.ensure([], () => r(require('@/pages/not')), 'not');
const myqx = r => require.ensure([], () => r(require('@/pages/403')), '403');
const fsjl = r => require.ensure([], () => r(require('@/pages/fsjl')), 'fsjl');
const dxpz = r => require.ensure([], () => r(require('@/pages/dxpz')), 'dxpz');
const dxcz = r => require.ensure([], () => r(require('@/pages/dxcz')), 'dxcz');
const czjl = r => require.ensure([], () => r(require('@/pages/czjl')), 'czjl');
const xtxx = r => require.ensure([], () => r(require('@/pages/gonggao')), 'xtxx');
const grsz = r => require.ensure([], () => r(require('@/pages/grsz')), 'grsz');
const tel = r => require.ensure([], () => r(require('@/pages/tel')), 'tel');
const rz = r => require.ensure([], () => r(require('@/pages/renzhen')), 'rz');
const czrz = r => require.ensure([], () => r(require('@/pages/czrz')), 'czrz');
const shrz = r => require.ensure([], () => r(require('@/pages/shrz')), 'shrz');
const fbgg = r => require.ensure([], () => r(require('@/pages/fbgg')), 'fbgg');
const adduser = r => require.ensure([], () => r(require('@/pages/adduser')), 'adduser');
const mima = r => require.ensure([], () => r(require('@/pages/mima')), 'mima');

Vue.use(Router)
Vue.use(ElementUI);

let router = new Router({
  // mode: 'history',
  routes: [
    {path:'',component:index},
    {path:'/',component:index},
    {path:'/index',component:index},
    {path: '*',component: not},
    {path: '/403',component: myqx},
    {path: '/login',meta: {islogin: true},component: login},
    {
      path: '/admin',
      name: '',
      component: min,
      meta: {allowBack: false,islogin:true,isqx:5},
      children:[
        {path:'',component:HelloWorld,meta:{title:["首页"],islogin:true,isqx:5}},
        {path:'/index',component:HelloWorld,meta:{title:["首页"],islogin:true,isqx:5}},
        {path:'/fsjl',component:fsjl,meta:{title:["首页","短信","发送记录"],islogin:true,isqx:5}},
        {path:'/dxpz',component:dxpz,meta:{title:["首页","短信","短信配置"],islogin:true,isqx:5}},
        {path:'/dxcz',component:dxcz,meta:{title:["首页","财务","短信充值"],islogin:true,isqx:5}},
        {path:'/czjl',component:czjl,meta:{title:["首页","财务","充值记录"],islogin:true,isqx:5}},
        {path:'/xtxx',component:xtxx,meta:{title:["首页","设置","系统消息"],islogin:true,isqx:5}},
        {path:'/grsz',component:grsz,meta:{title:["首页","设置","个人设置"],islogin:true,isqx:5}},
        {path:'/rz',component:rz,meta:{title:["首页","设置","实名认证"],islogin:true,isqx:5}},
        {path:'/mima',component:mima,meta:{title:["首页","设置","密码安全"],islogin:true,isqx:5}},
        {path:'/tel',component:tel,meta:{title:["首页","设置","手机认证"],islogin:true,isqx:5}},
        {path:'/czrz',component:czrz,meta:{title:["首页","超级设置","操作日志"],islogin:true,isqx:2}},
        {path:'/shrz',component:shrz,meta:{title:["首页","超级设置","认证信息"],islogin:true,isqx:2}},
        {path:'/fbgg',component:fbgg,meta:{title:["首页","超级设置","公告信息"],islogin:true,isqx:2}},
        {path:'/user',component:adduser,meta:{title:["首页","超级设置","用户管理"],islogin:true,isqx:2}},
      ]
    },
  ],
  strict: process.env.NODE_ENV !== 'production'
})
router.beforeEach((to, from, next) => {
  // //console.log('to:' + to.path)
  // var that =this;
  // //console.log(that.a.app)
  // //console.log(that.a.apps)
  // //console.log(to)
  // let token = JSON.parse(window.localStorage.getItem('access-user'))
  if(to.meta.islogin){
    API.login().then(function (result) {
      // //console.log(result)
      if(result.code==200){
        // //console.log(JSON.parse(API.base64decode(result.data)))
        localStorage.setItem('access-user', result.token);
        var user=JSON.parse(API.base64decode(result.data));
        // window.addEventListener
        window.dict=user;
        if(to.path=='/login'){
          next('/');
        }else{
          if(user.isqx<=to.meta.isqx){
            next();
          }else{
            next('/403');
          }
        }
      }else{
        // window.localStorage.removeItem('access-user')
        if(to.path!='/login'){
          next('/login?path='+to.path);
        }else{
          next();
        }
      }
    })
  }else{
    next();
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js